import React from 'react';

import { List, FilterForm, Datagrid } from 'components/list';
import { TextInput } from 'components/input';
import { TextField, BooleanField } from 'components/field';
import { EditButton } from 'components/button';

import {
  adminUserEditFrontendPath
} from './urls';

export const AdminUserFilter = (props) => (
  <FilterForm name="admin_user_search" {...props}>
    <TextInput label="Username" source="username"/>
  </FilterForm>
);

export const AdminUserList = (props) => (
  <List hasCreate={true} {...props} filters={<AdminUserFilter />}>
    <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
      <TextField source="id" label="ID"/>
      <TextField source="username" label="Username"/>
      <TextField source="first_name" label="First Name"/>
      <TextField source="last_name" label="Last Name"/>
      <TextField source="group_name" label="Group"/>
      <BooleanField source="is_active" label="Active"/>
      <BooleanField source="is_superuser" label="Superuser"/>
      <EditButton linkTo={adminUserEditFrontendPath}/>
    </Datagrid>
  </List>
);




// WEBPACK FOOTER //
// ./src/routes/user/AdminUserList.js